import register from '@kpsys/angularjs-register';
import homeRoutes from './home.routes';

export default register('portaro.features.home')
    .config(homeRoutes)
    .name();